<template>
    <form ref="order_payment">
        <div class="card__header">
            <p class="card__title">Payment</p>
            <p class="card__subtitle">You don’t have a payment method linked to your account yet. Please fill in the form below.</p>
        </div>
        <div class="card__content">
            <div class="form">
                <div class="form__field">
                    <label for="card-holder" class="form__label">Cardholder name</label>
                    <input type="text" name="card_holder" id="card-holder" class="form__control form-field required" placeholder="JOHN DOE" v-model="card.name">
                </div>
                <div class="form__field">
                    <label for="card-number" class="form__label">Card number</label>
                    <input type="text" name="card_number" id="card-number" class="form__control form-field required" maxlength="19" placeholder="**** **** **** 9845" v-model="card.number">
                </div>
                <div class="form__field form__field--md6">
                    <label for="card_expiry-date" class="form__label">Expiry date</label>
                    <input type="text" name="card_expiry-date" id="card_expiry-date" class="form__control form-field required" maxlength="5" placeholder="01/23" v-model="card.exp_date">
                </div>
                <div class="form__field form__field--md6">
                    <label for="card-cvc" class="form__label">Security code</label>
                    <input type="number" name="card_cvc" id="card-cvc" class="form__control form-field required" maxlength="4" placeholder="***" v-model="card.cvc">
                </div>
            </div>
        </div>
        <div v-if="$parent.loading">
            <popup-loader></popup-loader>
        </div>
        <div class="card__actions">
            <button type="button" class="button button--md button--grey" v-on:click="$parent.step = 'SUMMARY'">Back</button>
            <button type="button" class="button button--md button--secondary" v-on:click="sendOrder()">Order</button>
        </div>
    </form>
</template>

<script>
export default {
    data() {
        return {
            card: {}
        }
    },

    beforeMount() {
    },

    mounted() {
    },

    methods: {
        sendOrder() {
            if (!$(this.$refs.order_payment).valid()) return false;

            this.$parent.sendOrder(this.card);
        }
    }
}
</script>
